import {
  Box,
  Button,
  Card,
  CardBody,
  Flex,
  Heading,
  Image,
  List,
  ListItem,
  ListIcon,
  OrderedList,
  UnorderedList,
  Stack,
  Text,
} from "@chakra-ui/react";
import React from "react";
import { FaAngleRight, FaGithub, FaLink } from "react-icons/fa";
// import "./AboutMe.css";

import "./Experience.css";

const Experience = () => {
  return (
    <>
      <hr
        className="hrClass"
        style={{
          height: 5,
          backgroundColor: "#29242a",
        }}
      />

      <div id="experience" className="experience">
        <Box className="mainexp" color={"#dcdcda"}>
          <Box>
            <Heading
              textDecoration={"underline"}
              fontSize={50}
              textUnderlineOffset="10px"
              textDecorationStyle={"solid"}
              textDecorationColor={"orange"}
              color={"#15110D"}
            >
              My Professional Experience{" "}
            </Heading>
            <br />
          </Box>
          <br />
          <Card className="expCard" backgroundColor={"#b69673"}>
            <CardBody className="expCardBody">
              <Text className="titleEx" color={"#15110D"} fontWeight={"bold"}>
                SDE-Intern (Remote)
              </Text>
              <Text className="exCompDetails">
                Company Name: Masai School, Bangalore - Sep 2023 to Present
              </Text>
              <Text lineHeight={"1.3rem"}>
                As a Software Development Engineer Intern at Masai School, I've
                had the opportunity to gain hands-on experience in web
                development while utilizing a diverse tech stack. Proficient in
                HTML, CSS, JavaScript, React Query, and ReactJS, I've
                contributed to building and enhancing College Network project
                with a strong emphasis on user-friendly design and
                functionality.
              </Text>
              <Text fontWeight={"bold"}>Development:</Text>
              <Text className="details">
                Collaborated with the development team to create, customize, and
                optimize masai school web sites and college network website and
                application. Utilized technologies like JavaScript, HTML,
                CSS,react query and React JS to develop and integrate responsive
                and engaging user experiences within websites.
              </Text>

              <Text fontWeight={"bold"}>Projects:</Text>
              <UnorderedList lineHeight={"1.5rem"}>
                <ListItem>
                  <Text className="details">
                    Masai Dashboard (Clone)
                    <br />
                    -Team Work Project where we implement masai dashboard with
                    working state and responsive web pages.
                    <br />
                    -Working with backend team for better implementation.
                    <br />
                    <Box className="expLinks">
                      <Text>Project Links</Text>
                      <Box className="expDepLinks">
                        <a
                          href="https://mock-onward-fe-rho.vercel.app/login"
                          target="_blank"
                          rel="noreferrer"
                        >
                          <Button
                            background="orange"
                            color={"black"}
                            _hover={{ color: "black" }}
                            padding={"0.5rem"}
                            marginTop={"1rem"}
                            marginLeft={"1rem"}
                          >
                            <Text as={"span"} marginRight={"0.5rem"}>
                              <FaLink />
                            </Text>{" "}
                            Deploy Link
                          </Button>
                        </a>
                        <a
                          href="https://github.com/kiranwankhade/mock-onward-fe"
                          target="_blank"
                          rel="noreferrer"
                        >
                          <Button
                            background="orange"
                            color={"black"}
                            _hover={{ color: "white" }}
                            padding={"0.5rem"}
                            marginTop={"1rem"}
                            marginLeft={"1rem"}
                          >
                            <Text as={"span"} marginRight={"0.5rem"}>
                              <FaGithub />
                            </Text>{" "}
                            GitHub Code
                          </Button>
                        </a>
                      </Box>
                    </Box>
                  </Text>
                </ListItem>
                <br/>
                <ListItem>
                  <Text className="details">
                    College Network (Team Project)
                    <br />
                    -Project where we implement college university project with
                    working state and responsive web pages.
                    <br />
                    -Implement Frontend pages with responsive.
                    <br />
                    -Implement admin work platform(frontend dynamic).
                    <br />
                    <Box className="expLinks">
                      <Text>Project Links</Text>
                      <Box className="expDepLinks">
                        <a
                          href="https://sharda.prepleaf.com/"
                          target="_blank"
                          rel="noreferrer"
                        >
                          <Button
                            background="orange"
                            color={"black"}
                            _hover={{ color: "black" }}
                            padding={"0.5rem"}
                            marginTop={"1rem"}
                            marginLeft={"1rem"}
                          >
                            <Text as={"span"} marginRight={"0.5rem"}>
                              <FaLink />
                            </Text>{" "}
                            Deploy Link
                          </Button>
                        </a>
                      </Box>
                    </Box>
                  </Text>
                </ListItem>
              </UnorderedList>
              <Text className="technology">Technologies used:</Text>
              <UnorderedList lineHeight={"1.5rem"}>
                <ListItem>HTML</ListItem>
                <ListItem>CSS</ListItem>
                <ListItem>JavaScript</ListItem>
                <ListItem>React JS</ListItem>
                <ListItem>React Query</ListItem>
              </UnorderedList>
            </CardBody>
          </Card>

          <br />
          <Card className="expCard" backgroundColor={"#b69673"}>
            <CardBody className="expCardBody">
              <Text className="titleEx" color={"#15110D"} fontWeight={"bold"}>
                iOS Developer
              </Text>
              <Text className="exCompDetails">
                Company Name: Inceptive Technologies, Pune - July 2019 to Jan
                2020
              </Text>
              <Text lineHeight={"1.3rem"}>
                As an iOS Developer at Inceptive Technologies, I've had the
                opportunity to gain hands-on experience in web development and
                iOS development while utilizing a Different useful tech stack.
                Proficient in HTML, CSS, JavaScript,and Swift, I've contributed
                to building and enhancing HoneyWell project where Worked on
                creating a web application for a tablet that has statics RAM.
                Handle clients.
              </Text>
              <Text fontWeight={"bold"}>Development:</Text>
              <Text className="details">
                Collaborated with the development team to create, customize web
                application for tablet for client honeywell. Utilized
                technologies like JavaScript, HTML and CSS to develop and
                integrate responsive and engaging user experiences within web
                application.
              </Text>
              <Text className="technology">Technologies used:</Text>
              <UnorderedList lineHeight={"1.5rem"}>
                <ListItem>HTML</ListItem>
                <ListItem>CSS</ListItem>
                <ListItem>JavaScript</ListItem>
                <ListItem>Swift</ListItem>
              </UnorderedList>
            </CardBody>
          </Card>
          <br />
          <br />
        </Box>
      </div>
    </>
  );
};

export default Experience;
